module.exports = __webpack_public_path__ + "static/scale-model-of-the-nelson-atkins-museum-of-art-in-kansas-city-missouri-313a82b6ed6bbfc230241a7cacb097c9.png";